/**
 * Dutch (NL) Ticket Confirmation email template (HTML).
 * Mirrors TICKET_CONFIRMATION_EMAIL_TEMPLATE_HTML but in Dutch,
 * based on the NL ticket-ready template structure.
 * Placeholders use {{key}} syntax.
 */
export const TICKET_CONFIRMATION_EMAIL_TEMPLATE_HTML_NL = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml"
      xmlns:v="urn:schemas-microsoft-com:vml"
      xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="format-detection" content="telephone=no" />
    <meta name="format-detection" content="date=no" />
    <meta name="format-detection" content="address=no" />
    <meta name="format-detection" content="email=no" />
    <title>Uw evenementsticket is klaar</title>

    <!--[if gte mso 9]>
      <xml>
        <o:OfficeDocumentSettings>
          <o:AllowPNG />
          <o:PixelsPerInch>96</o:PixelsPerInch>
        </o:OfficeDocumentSettings>
      </xml>
    <![endif]-->

    <style type="text/css">
        /* Reset styles */
        body {
            margin: 0 !important;
            padding: 0 !important;
            -webkit-text-size-adjust: 100% !important;
            -ms-text-size-adjust: 100% !important;
            -webkit-font-smoothing: antialiased !important;
        }

        img {
            border: 0 !important;
            outline: none !important;
            display: block;
        }

        table {
           border-collapse:separate !important;
            mso-table-lspace: 0pt !important;
            mso-table-rspace: 0pt !important;
        }

        td {
            border-collapse: separate !important;
        }

        a {
            text-decoration: none;
        }

        /* Client-specific styles */
        .ReadMsgBody {
            width: 100%;
        }

        .ExternalClass {
            width: 100%;
        }

            .ExternalClass,
            .ExternalClass p,
            .ExternalClass span,
            .ExternalClass font,
            .ExternalClass td,
            .ExternalClass div {
                line-height: 100%;
            }

        /* iOS blue links */
        a[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: none !important;
            font-size: inherit !important;
            font-family: inherit !important;
            font-weight: inherit !important;
            line-height: inherit !important;
        }

        /* Gmail blue links */
        u + #body a {
            color: inherit;
            text-decoration: none;
            font-size: inherit;
            font-family: inherit;
            font-weight: inherit;
            line-height: inherit;
        }

        /* Responsive styles */
        @media only screen and (max-width: 600px) {
            .wrapper {
                width: 100% !important;
            }

            .container {
                width: 100% !important;
                padding-left: 20px !important;
                padding-right: 20px !important;
            }

            .mobile-padding {
                padding-left: 15px !important;
                padding-right: 15px !important;
            }

            .mobile-hide {
                display: none !important;
            }

            .mobile-text-center {
                text-align: center !important;
            }
        }
    </style>
</head>

<body id="body" style="margin: 0; padding: 0; background-color: #f5f5f8">
    <!-- Preheader text (hidden) -->
    <div style="
        display: none;
        font-size: 1px;
        color: #f5f5f8;
        line-height: 1px;
        max-height: 0px;
        max-width: 0px;
        opacity: 0;
        overflow: hidden;
      ">
        Er is een ticket aan u toegewezen voor het evenement.
        U kunt nu uw ticket bekijken en alle relevante evenementgegevens op één plek vinden.
    </div>

    <!-- Main wrapper table -->
    <table role="presentation"
           width="100%"
           border="0"
           cellspacing="0"
           cellpadding="0"
           style="background-color: #f5f5f8">
        <tr>
            <td align="center" style="padding: 40px 20px">
                <!-- 600px container -->
                <table role="presentation"
                       class="wrapper"
                       width="600"
                       border="0"
                       cellspacing="0"
                       cellpadding="0"
                       style="
              width: 600px;
              max-width: 100%;
              background-color: {{Primary_Color}};
              border-radius: 16px;
              overflow: hidden;
              box-shadow: 0px 25px 50px -12px #00000040;
            ">
                    <!-- Header with logo -->
                    <tr>
                        <td align="center" style="padding:32px 40px 24px 40px; background-color:#ffffff;">

                            <table role="presentation" border="0" cellspacing="0" cellpadding="0" align="center">
                                <tr>
                                    <td align="center"
                                        valign="middle"
                                        width="130"
                                        height="130"
                                        style="border:1px solid #000000; border-radius:65px;">
                                        <img src="{{branding.logoUrl}}"
                                             alt="{{branding.logoAlt}}"
                                             width="100"
                                             style="display:block; border:0; height:auto;" />
                                    </td>
                                </tr>
                            </table>

                        </td>
                    </tr>

                    <!-- Enjoy the event Badge -->
                    {{emailBadgeRow}}
                    {{HeaderImageBlock_START}}<tr>
                        <td align="center" style="padding:16px 40px;background:#ffffff;">

                            <table role="presentation" width="100%" style="max-width:504px;" cellpadding="0" cellspacing="0">
                                <tr>
                                    <td align="center">

                                        <img src="{{Rectangle.Img}}"
                                             width="504"
                                             style="display:block;width:100%;max-width:504px;height:auto;border-radius:32px;"
                                             alt="" />

                                    </td>
                                </tr>
                            </table>

                        </td>
                    </tr>{{HeaderImageBlock_END}}

                    <!-- Main heading -->
                    {{emailHeadingRow}}

                    {{emailBodyRow}}

                    <!-- Ticket details Section -->
                    <tr>
                        <td style="padding: 40px 40px 32px 40px">
                            <table role="presentation"
                                   width="100%"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0"
                                   style="
                    background-color: #ffffff;
                    border-radius: 16px;
                    padding: 32px;
                  ">
                                <tr>
                                    <td style="padding: 0px">
                                        <table role="presentation"
                                               width="100%"
                                               border="0"
                                               cellspacing="0"
                                               cellpadding="0">
                                            {{emailEventDetailsHeadingRow}}
                                         

                                            <!-- Date and Time row -->
                                            <tr>
                                                <td style="
                              padding-bottom: 16px;
                              width: 50%;
                              vertical-align: top;
                              padding-right: 8px;
                            ">
                                                    <table role="presentation"
                                                           width="100%"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="48"
                                                                style="
                                    vertical-align: top;
                                    padding-right: 12px;
                                  ">
                                                                <!-- <img
                                                  src="{{Date.Icon}}"
                                                  alt="Date"
                                                  width="48"
                                                  height="48"
                                                  style="
                                                    display: block;
                                                    width: 48px;
                                                    height: 48px;
                                                  "
                                                /> -->
                                                                <img src="{{Network.Icon}}"
                                                                     alt="Date"
                                                                     width="48"
                                                                     height="48"
                                                                     style="
                                      display: block;
                                      width: 48px;
                                      height: 48px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: top">
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      color: #637381;
                                      line-height: 16px;
                                      letter-spacing: 1px;
                                    ">
                                                                    STAND
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 15px;
                                      font-weight: 400;
                                      color: #161c24;
                                      line-height: 22px;
                                    ">
                                                                    {{ticket.stand}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>

                                                <!-- Time -->
                                            </tr>
                                            <tr>
                                                <td style="
                              padding-bottom: 16px;
                              width: 50%;
                              vertical-align: top;
                            ">
                                                    <table role="presentation"
                                                           width="100%"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="48"
                                                                style="
                                    vertical-align: top;
                                    padding-right: 12px;
                                  ">
                                                                <img src="{{Network.Icon}}"
                                                                     alt="Time"
                                                                     width="48"
                                                                     height="48"
                                                                     style="
                                      display: block;
                                      width: 48px;
                                      height: 48px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: top">
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      color: #637381;
                                      line-height: 16px;
                                      letter-spacing: 1px;
                                    ">
                                                                    RIJ
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 15px;
                                      font-weight: 400;
                                      color: #161c24;
                                      line-height: 22px;
                                    ">
                                                                    {{ticket.row}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <!-- Location row -->
                                            <tr>
                                                <td colspan="2">
                                                    <table role="presentation"
                                                           width="100%"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="48"
                                                                style="
                                    vertical-align: top;
                                    padding-right: 12px;
                                  ">
                                                                <img src="{{Network.Icon}}"
                                                                     alt="Location"
                                                                     width="48"
                                                                     height="48"
                                                                     style="
                                      display: block;
                                      width: 48px;
                                      height: 48px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: top">
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      color: #637381;
                                      line-height: 16px;
                                      letter-spacing: 1px;
                                    ">
                                                                    STOEL
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 15px;
                                      font-weight: 400;
                                      color: #161c24;
                                      line-height: 22px;
                                    ">
                                                                    {{ticket.seat}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <!-- Let op -->
                    <tr>
                        <td style="
                  margin: 0;
                  font-family:
                    -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;,
                    Roboto, Helvetica, Arial, sans-serif;
                  font-size: 16px;
                  color: {{Contrast_Color}};
                  line-height: 25px;
                  letter-spacing: 0px;
                  text-align: center;
                  padding: 0 40px 30px 40px;
                  background-color: {{Primary_Color}};
                ">
                            Let op: Houd dit ticket tijdens het evenement bij u voor eenvoudige toegang
                            en verificatie
                        </td>
                    </tr>

                    <!-- CTA Button -->
                    {{Button_Block_START}}<tr>
                        <td align="center"
                            style="padding: 0 40px 40px 40px; background-color: {{Primary_Color}}">
                            <!--[if mso]>
              <v:roundrect
                xmlns:v="urn:schemas-microsoft-com:vml"
                xmlns:w="urn:schemas-microsoft-com:office:word"
                href="{{ticket.viewUrl}}"
                style="height: 48px; v-text-anchor: middle; width: 220px"
                arcsize="21%"
                strokecolor="#ffffff"
                fillcolor="#ffffff"
              >
                <w:anchorlock />
                <center
                  style="
                    color: {{Primary_Color}};
                    font-family: sans-serif;
                    font-size: 15px;
                    font-weight: 400;
                  "
                >
                  {{emailButtonText}}
                </center>
              </v:roundrect>
            <![endif]-->
                            <!--[if !mso]><!-->
                            <table role="presentation"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0"
                                   align="center"
                                   style="mso-hide: all">
                                <tr>
                                    <td align="center"
                                        style="
                        background-color: #ffffff;
                        border-radius: 10px;
                        -webkit-border-radius: 10px;
                        -moz-border-radius: 10px;
                      ">
                                        <a href="{{ticket.viewUrl}}"
                                           style="
                          display: inline-block;
                          background-color: #ffffff;
                          color: {{Primary_Color}};
                          font-family:
                            -apple-system, BlinkMacSystemFont,
                            &quot;Segoe UI&quot;, Roboto, Helvetica, Arial,
                            sans-serif;
                          font-size: 15px;
                          font-weight: 400;
                          text-decoration: none;
                          padding: 14px 32px;
                          border-radius: 10px;
                          line-height: 20px;
                          -webkit-border-radius: 10px;
                          -moz-border-radius: 10px;
                        ">
                                            <table role="presentation"
                                                   border="0"
                                                   cellspacing="0"
                                                   cellpadding="0">
                                                <tr>
                                                    <td style="
                                vertical-align: middle;
                                padding-right: 20px;
                              ">
                                                        <span style="
                                  font-family:
                                    -apple-system, BlinkMacSystemFont,
                                    &quot;Segoe UI&quot;, Roboto, Helvetica,
                                    Arial, sans-serif;
                                  font-size: 15px;
                                  font-weight: 400;
                                  color: {{Primary_Color}};
                                  line-height: 20px;
                                ">
                                                            {{emailButtonText}}
                                                        </span>
                                                    </td>
                                                    <td style="vertical-align: middle; line-height: 0">
                                                        <img src="{{Arrow.Icon}}"
                                                             height="18"
                                                             width="18"
                                                             alt=""
                                                             style="
                                  display: block;
                                  width: 18px;
                                  height: 18px;
                                " />
                                                    </td>
                                                </tr>
                                            </table>
                                        </a>
                                    </td>
                                </tr>
                            </table>
                            <!--<![endif]-->
                        </td>
                    </tr>{{Button_Block_END}}

                    <tr>
                        <td align="center"
                            style="padding: 0 40px 40px 40px; color: {{Contrast_Color}};">
                            <!--Dynamic Pdf Note-->
                        </td>
                    </tr>

                    <!-- Footer -->
                    <!-- Footer -->
                    <tr>
                        <td align="center"
                            style="padding: 32px 40px; background-color: #f9fafb">
                            <!-- Questions text -->
                            <p style="
                    margin: 0 0 8px 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;,
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 14px;
                    font-weight: 400;
                    color: #637381;
                    line-height: 20px;
                    text-align: center;
                  ">
                                Heeft u vragen?
                            </p>
                            <p style='
                    margin: 0 0 20px 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, "Segoe UI",
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 14px;
                    color: {{Primary_Color}};
                    line-height: 20px;
                    text-align: center;
                  '>
                                <a href="mailto:{{branding.contactEmail}}"
                                   style="color: {{Primary_Color}}; text-decoration: none">Neem contact op met ons evenemententeam</a>
                            </p>

                            <!-- Social icons -->
                            <table role="presentation"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0"
                                   align="center">
                                <tr>
                                    <!-- {{#if branding.socialLinks.facebook}} -->
                                    <td style="padding: 0 6px">
                                        <a href="{{branding.socialLinks.facebook}}"
                                           style="display: block; text-decoration: none">
                                            <table role="presentation" border="0" cellspacing="0" cellpadding="0"
                                          
                                                  <tr style="border: 1px solid rgba(29, 29, 27, .2); display: block; padding: 5px">
                                                    <td align="center" valign="middle" style="line-height: 0">
                                                        <img src="{{Facebook.Icon}}" alt="Facebook" width="16px" height="16px"
                                                             style="display: block; width: 16px; height: 16px;" />
                                                    </td>
                                                </tr>
                                            </table>
                                        </a>
                                    </td>
                                    <td style="padding: 0 6px">
                                        <a href="{{branding.socialLinks.instagram}}"
                                           style="display: block; text-decoration: none">
                                            <table role="presentation" border="0" cellspacing="0" cellpadding="0"
                                          
                                                  <tr style="border: 1px solid rgba(29, 29, 27, .2); display: block; padding: 5px">
                                                    <td align="center" valign="middle" style="line-height: 0">
                                                        <img src="{{Instagram.Icon}}" alt="Instagram" width="16px" height="16px"
                                                             style="display: block; width: 16px; height: 16px;" />
                                                    </td>
                                                </tr>
                                            </table>
                                        </a>
                                    </td>
                                    <!-- {{/if}} {{#if branding.socialLinks.linkedin}} -->
                                    <td style="padding: 0 6px">
                                        <a href="{{branding.socialLinks.linkedin}}"
                                           style="display: block; text-decoration: none">
                                            <table role="presentation" border="0" cellspacing="0" cellpadding="0"
                                          
                                                <tr style="border: 1px solid rgba(29, 29, 27, .2); display: block; padding: 5px">
                                                    <td align="center" valign="middle" style="line-height: 0">
                                                        <img src="{{LinkedIn.Icon}}" alt="LinkedIn" width="16px" height="16px"
                                                             style="display: block; width: 16px; height: 16px;" />
                                                    </td>
                                                </tr>
                                            </table>
                                        </a>
                                    </td>
                                    <!-- {{/if}} -->
                                </tr>
                            </table>

                            <!-- Divider between social media and logo -->
                            <table role="presentation" border="0" cellspacing="0" cellpadding="0" align="center"
                                   style="margin-top: 24px; margin-bottom: 24px; width: 100%">
                                <tr>
                                    <td style="
                        border-top: 1px solid #9a9a983d;
                        height: 1px;
                        line-height: 1px;
                        font-size: 1px;
                      ">
                                        &nbsp;
                                    </td>
                                </tr>
                            </table>

                            <!-- Logo -->
                            <table role="presentation" border="0" cellspacing="0" cellpadding="0" align="center"
                                   style="margin-bottom: 16px">
                                <tr>
                                    <td align="center">
                                        <table role="presentation" border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                               
                                                 <td style="vertical-align: middle; padding-right: 8px">
                                                    <img src="{{VDK.Icon}}"
                                                         alt="VDK Logo"
                                                        
                                                         style="display: block; width: 100px; height: auto" />
                                                </td>
                                              
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>

                            <!-- Copyright -->
                            <p style="
                    margin: 0 0 4px 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;,
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 12px;
                    font-weight: 400;
                    color: #637381;
                    line-height: 18px;
                    text-align: center;
                  ">
                                © 2026 VDK Groep. Alle rechten voorbehouden.
                            </p>

                            <!-- Links -->
                            <p style="
                    margin: 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;,
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 12px;
                    font-weight: 400;
                    color: #637381;
                    line-height: 18px;
                    text-align: center;
                  ">
                                <!--<a href="{{legal.unsubscribeUrl}}"
                   style="color: #637381; text-decoration: underline">Uitschrijven</a>
                <span style="padding: 0 8px">•</span>
                <a href="{{legal.viewInBrowserUrl}}"
                   style="color: #637381; text-decoration: underline">Bekijk in browser</a>-->
                            </p>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>`;
/** Row HTML for email body; use with {{emailBody}} inside. Substitute entire row as {{emailBodyRow}} (empty when body is empty). */
export const EMAIL_BODY_ROW_HTML = `<tr>
                        <td align="center"
                            style="padding: 0 60px 32px 60px; background-color: #ffffff">
                            <div class="email-body-content" style="
                    margin: 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;,
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 16px;
                    font-weight: 400;
                    color: #637381;
                    line-height: 1.375;
                    text-align: center;
                  ">
                                {{emailBody}}
                            </div>
                        </td>
                    </tr>`;
/** Row HTML for email heading; use with {{emailHeading}} inside. Substitute entire row as {{emailHeadingRow}} (empty when heading is empty). */
export const EMAIL_HEADING_ROW_HTML = `<tr>
                        <td align="center"
                            style="padding: 0 40px 16px 40px; background-color: #ffffff">
                            <h1 style="
                    margin: 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;,
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 42px;
                    font-weight: 400;
                    color: #161c24;
                    line-height: 1.2;
                    letter-spacing: 0.5px;
                    text-align: center;
                  ">
                                {{emailHeading}}
                            </h1>
                        </td>
                    </tr>`;
/** Row HTML for event details heading; substitute as {{emailEventDetailsHeadingRow}} (empty when heading is empty). */
export const EMAIL_EVENT_DETAILS_HEADING_ROW_HTML = `<tr>
                                                <td style="
                              font-family:
                                -apple-system, BlinkMacSystemFont,
                                &quot;Segoe UI&quot;, Roboto, Helvetica, Arial,
                                sans-serif;
                              font-size: 20px;
                              font-weight: 400;
                              color: #161c24;
                              line-height: 1.5;
                            ">
                                                    {{emailEventDetailsHeading}}
                                                </td>
                                            </tr>`;
/** Row HTML for event details subtext; substitute as {{emailEventDetailsSubtextRow}} (empty when subtext is empty). */
export const EMAIL_EVENT_DETAILS_SUBTEXT_ROW_HTML = `<tr>
                                                <td style="
                              font-family:
                                -apple-system, BlinkMacSystemFont,
                                &quot;Segoe UI&quot;, Roboto, Helvetica, Arial,
                                sans-serif;
                              font-size: 16px;
                              font-weight: 400;
                              color: #575756;
                              padding-bottom: 12px;
                              line-height: 1.375;
                            ">
                                                    {{emailEventDetailsSubtext}}
                                                </td>
                                            </tr>`;
/**
 * Default placeholder values for Dutch ticket confirmation email preview.
 */
export const DEFAULT_TICKET_CONFIRMATION_PLACEHOLDER_VALUES_NL = {
    // Editor-driven keys
    emailBadge: 'Geniet van het evenement',
    emailButtonText: 'Bekijk ticket',
    emailHeading: 'Uw ticket is<br />bevestigd!',
    emailBody: '<p>Uw deelname aan <strong style="color: #161c24;">{{field:sys:eventName}}</strong> is bevestigd. We kijken ernaar uit u te verwelkomen!</p>',
    emailEventDetailsHeading: 'Evenementgegevens',
    //   emailEventDetailsSubtext: 'Alles wat u moet weten',
    // Evenement
    'event.title': 'Evenementnaam',
    'event.description': 'Evenementbeschrijving',
    emailDate: '{{sys:eventDate}}',
    emailTime: '{{sys:eventStartTime}} - {{sys:eventEndTime}}',
    emailLocation: '{{sys:eventLocation}}',
    // Ticket
    'ticket.number': 'TKT-000123',
    'ticket.stand': 'Noord Tribune',
    'ticket.row': 'B',
    'ticket.seat': '14',
    'ticket.viewUrl': '#',
    // Deelnemer
    'attendee.name': 'Jan Jansen',
    'attendee.company': 'Bedrijf',
    'attendee.email': 'jan@voorbeeld.nl',
    // Huisstijl / kleuren
    Primary_Color: '#e94e1b',
    Contrast_Color: '#161c24',
    'branding.logoUrl': '{{branding.logoUrl}}',
    'branding.logoAlt': 'Logo',
    'branding.contactEmail': 'evenementen@voorbeeld.nl',
    'branding.socialLinks.facebook': '#',
    'branding.socialLinks.instagram': '#',
    'branding.socialLinks.linkedin': '#',
    // Afbeeldingen & iconen
    'Rectangle.Img': '/assets/images/rectangle.png',
    HeaderImageBlock_START: '',
    HeaderImageBlock_END: '',
    'Date.Icon': '',
    'Time.Icon': '',
    'Location.Icon': '',
    'Ticket.Icon': '',
    'Network.Icon': '',
    'Arrow.Icon': '',
    'Dot.Icon': '',
    'Facebook.Icon': '/assets/images/social-media-icons/facebook-icon.png',
    'Instagram.Icon': '/assets/images/social-media-icons/instagram-icon.png',
    'LinkedIn.Icon': '/assets/images/social-media-icons/linkedin-icon.png',
    'VDK.Icon': '/assets/images/vdkLogo-nl.svg'
};
/**
 * Default rich-text body for the Dutch ticket confirmation email editor
 * (P0=heading, P1=body, P2=Event details heading, P3=Event details subtext).
 */
export const DEFAULT_NEW_EVENT_TICKET_EMAIL_BODY_DUTCH = '{"emailHeading":"Uw ticket is<br />bevestigd!","emailBody":"<p>Uw deelname aan <strong style=\\"color: #161c24;\\">{{field:sys:eventName}}</strong> is bevestigd. We kijken ernaar uit u te verwelkomen!</p>","emailEventDetailsHeading":"Evenementgegevens","emailEventDetailsSubtext":"Alles wat u moet weten","emailBadge":"Geniet van het evenement","emailButtonText":"Ticket bekijken"}';
